import { findFieldModule, getAdditionalTestTypeName } from "./helperfunc";

export const useActiveTestType = (fieldName) => {
  // will return test_type we needed to call API
  const { isExternal, isInternal, isAdditional } = findFieldModule(fieldName)

  const parts = fieldName.split('[');
  let last = parts[parts.length - 1].replaceAll(']', '');
  const secondLast = parts[parts.length - 2].replaceAll(']', '');
  let testType = `${secondLast}_${last}`
  if (isExternal === true || isInternal === true || isAdditional === true) {
    if (isAdditional) {
      let res = getAdditionalTestTypeName(fieldName);
      return res
    }
    testType = keys.includes(testType) ? fields[testType] : testType
    return testType
  }
  if (testType === 'binocular_note' || testType ==="priliminaries_notes") {
    last = testType
  }
  return last;
};

const keys = ['internal_attributes_od_cd', 'internal_attributes_os_cd', 'internal_attributes_dialation_inactive_reason', 'internal_attributes_dialation_od', 'internal_attributes_dialation_os']

const fields = {
  internal_attributes_od_cd: 'od_cd',
  internal_attributes_os_cd: 'os_cd',
  internal_attributes_dialation_inactive_reason: 'dialation_inactive_reason',
  internal_attributes_dialation_od: 'dialation_od',
  internal_attributes_dialation_os: 'dialation_os'
}